import _ from 'lodash';

import { REQUEST_TABLE_COLUMN_ORDER, TASK_TABLE_COLUMN_MAP } from '../../HelperMethods/AgGridConstants';
import { GLOBAL_APPROVAL_STATUS } from '../../HelperMethods/enums';

export const getColumnDefs = ({ checkboxRequired }) => {
  const columnOrder = _.cloneDeep(REQUEST_TABLE_COLUMN_ORDER);
  const clonedColumnsMap = _.cloneDeep(TASK_TABLE_COLUMN_MAP);
  if (clonedColumnsMap.actionButtons) {
    clonedColumnsMap.actionButtons.width = 100;
  }
  if (clonedColumnsMap.score) {
    clonedColumnsMap.score.width = 100;
  }
  const columnDefs = [];
  for (const columnKey of columnOrder) {
    if (columnKey === 'checkBoxColumn' && !checkboxRequired) {
      continue;
    }
    columnDefs.push(clonedColumnsMap[columnKey]);
  }
  return columnDefs;
};

export const bulkApprovalTaskList = (tasks) => {
  const taskIdList = [];
  for (const task of tasks) {
    taskIdList.push(task.id);
  }
  return taskIdList;
};

export const updateTaskAfterBulkApproval = (updatedTasks) => {
  const taskToBeUpdated = [];
  const taskToBeDeleted = [];
  for (const task of updatedTasks) {
    if (task.approvalStatus === GLOBAL_APPROVAL_STATUS.APPROVED.key) {
      taskToBeDeleted.push(task);
    } else {
      taskToBeUpdated.push(task);
    }
  }
  return { taskToBeDeleted, taskToBeUpdated };
};

export const REQUEST_TYPE = {
  WORK_REQUEST: 'workrequest',
  APPROVAL_REQUEST: 'approvalrequest',
};

export const filterDropdown = {
  ACTIVE_REQUEST: {
    key: 'ActiveRequests',
    value: 'activeRequests',
    text: 'All Active Requests',
  },
  APPROVED_REQUEST: {
    key: 'ApprovedRequests',
    value: 'approved',
    text: 'Approved Requests - (Custom Date Range)',
  },
  DENIED_REQUEST: {
    key: 'DeniedRequests',
    value: 'denied',
    text: 'Denied Requests - (Custom Date Range)',
  },
};

export const activeRequests = [
  GLOBAL_APPROVAL_STATUS.ON_HOLD.key,
  GLOBAL_APPROVAL_STATUS.NEED_MORE_INFO.key,
  GLOBAL_APPROVAL_STATUS.PENDING_APPROVAL.key,
];

export const filters = {
  dateRange: { endDate: new Date(), startDate: new Date() },
  selectedFilter: filterDropdown.ACTIVE_REQUEST,
};
